export enum CompanySettingsPermissions {
  appraisalsTab = 'companySettingsAppraisals',
  reviewerTab = 'companySettingsReviewer',
  employeesTab = 'companySettingsEmployees',
  rankingTab = 'companySettingsRanking',
  cultivatingTalentsTab = 'companySettingsCultivatingTalents',
  pyramidsTab = 'companySettingsPyramids',
  targetTemplatesTab = 'companySettingsTargetTemplates',
  reviewerFullSearch = 'reviewerFullSearch',
  companyMeetingRequests = 'companyMeetingRequests',
  targetReportsTab = 'companySettingsTargetReports',
  appraisalSeasonTab = 'appraisalSeasonTab',
  hrFeedbackTab = 'hrFeedbackTab',
  hrBusinessPartnersTab = 'hrBusinessPartnersTab',
  hrCountrySettingsTab = 'hrCountrySettingsTab',
  hrNationalContractReferenceTab = 'hrNationalContractReferenceTab',
}
